<template>
  <div>
    <div :class="[this.icon && this.icon.selected ? 'input-group mb-3' : 'form-group']" class="form-datetime" v-show="this.data.visibility !== 'hidden'">
      <label v-show="this.showLabel" :class="{'d-block w-100': this.showLabel && this.icon && this.icon.selected }"> {{label}} </label>
      <div class="input-group-prepend" v-if="this.icon && this.icon.position === 'left'">
        <span class="input-group-text"><i :class="['mdi', this.icon.selected]"></i></span>
      </div>
      <datetime v-model="value" :type="type" input-class="form-control" :name="this.data.tag"
                :placeholder="placeholder"></datetime>
      <div class="input-group-prepend" v-if="this.icon && this.icon.position === 'right'">
        <span class="input-group-text"><i :class="['mdi', this.icon.selected]"></i></span>
      </div>
      <small class="form-text text-muted" v-show="data.help_text != ''" :class="{'d-block w-100': this.showLabel && this.icon && this.icon.selected }">{{data.help_text}}</small>
    </div>
  </div>
</template>

<script>

	// Import this component
	import {Datetime} from 'vue-datetime';


	export default {
		props: ['label', 'data', 'value', 'type', 'showPlaceholder', 'showLabel', 'icon'],
		data() {
			return {}
		},
		computed: {
			placeholder() {
				return this.showPlaceholder ? this.label : ''
			},
		},
		components: {
			Datetime
		}
	}


</script>

<style lang="scss" scoped>
  .form-datetime{
    div.vdatetime{
      flex: 1;
    }
  }
</style>
